import request from '@/utils/request'

const baseCourseUrl = '/exam/examResourceCollect/'

// 查询字典数据列表-无分页
// export function getClassifyData(query) {
//   return request({
//     url: '/system/dict/data/getClassifyData',
//     method: 'get',
//     params: query
//   })
// }
// 课程列表查询
export function getCourseList (query) {
  return request({
    url: baseCourseUrl + 'list',
    method: 'get',
    params: query
  })
}
// 课程收藏
// export function getCollect (data) {
//   return request({
//     url: '/exam/examResourceCollect/add',
//     method: 'post',
//     data: data
//   })
// }
// // 详情接口
// export function getCourseDetail (id) {
//   return request({
//     url: baseCourseUrl + 'selectOne',
//     method: 'get',
//     params: {
//       id:id
//     }
//   })
// }

// // 详情-课件列表

// export function getCoursewareList (courseId) {
//   return request({
//     url: '/exam/examCourseCatalog/listForPc',
//     method: 'get',
//     params: {
//       courseId:courseId
//     }
//   })
// }


// // 计时结束保存
// export function getStudyRecord (data) {
//   return request({
//     url: '/exam/examWareStudyRecord/add',
//     method: 'post',
//     data: data
//   })
// }

// // 判断开课时间
// export function getCourseState (id) {
//   return request({
//     url: baseCourseUrl + 'selectOneForPc',
//     method: 'get',
//     params: {
//       id:id
//     }
//   })
// }
